export const commonPath = (index, keyName) => {
  return {
    COMMON: `[${index}][${keyName}]`,
  };
};

export const colourArrayPath = (index, colourIndex, colourKey) => {
  return {
    COLOUR_ARRAY_CHANGE: `[${index}].colourArray[${colourIndex}][${colourKey}]`,
  };
};

export const customColumnPath = (index, chIndex, chName) => {
  return {
    LABELCOLOURS_UPDATES: `[${index}].labelColoursOptions[${chIndex}][${chName}]`,
    STATUS_COLOURS: `[${index}].statusColoursOptions[${chIndex}][${chName}]`,
    STATUS_COLOURS_VALUE: `[${index}].statusColoursOptions[${chIndex}]`,
  };
};
